export default {"src":"/_next/static/media/left-arrow-disabled.31a0710c.svg","height":17,"width":10};